export enum Contrast {
    Plus3 = 'Plus3',
    Plus2 = 'Plus2',
    Plus1 = 'Plus1',
    Default = 'Default',
    Minus1 = 'Minus1',
    Minus2 = 'Minus2',
    Minus3 = 'Minus3',
}